import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const STICKY_NOTES = buildModuleApi({
    prefix: "STICKY_NOTES",
    uri: "sticky-notes",
    withExtra: false,
    exclude: [
        "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
        "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
    ],
    overrides: {
        LIST: { url: "/sticky-notes" },
        CREATE: { url: "/sticky-notes" },
        UPDATE: { url: "/sticky-notes/:id" },
        REMOVE: { url: "/sticky-notes/:id" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

export const STICKY_NOTES_CONSTANTS = STICKY_NOTES.CONSTANTS;
export const STICKY_NOTES_ENDPOINTS = STICKY_NOTES.ENDPOINTS;
